import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { formatDate } from '@/utils/date-utils';
import { ProjectType } from '@/gql/graphql';
import {
  BAlert,
  BButton,
  BButtonGroup,
  BCard,
  BTable,
} from 'bootstrap-vue-next';
import { openRouterLink } from '@/utils/router-utils';

export interface ProjectTypeExtended extends ProjectType {
  canEdit: boolean;
}

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectList',
  props: {
    projects: {},
    loading: { type: Boolean },
    showOwner: { type: Boolean }
  },
  setup(__props: any) {

const router = useRouter();

// --- Extended Project Inteface ---
const props = __props;

const noProjects = computed(() => {
  return props.projects.length === 0 && !props.loading;
});

// --- Project Table Fields ---
const projectTableFields = computed(() => {
  const fields = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      tdClass: 'align-middle',
    },
    {
      key: 'description',
      label: 'Description',
      sortable: true,
      tdClass: 'align-middle',
    },
    {
      key: 'createdAt',
      label: 'Created',
      sortable: true,
      formatter: formatDate,
      tdClass: 'align-middle',
    },
    { key: 'actions', label: '', tdClass: 'align-middle text-end' },
  ];
  // Kit field (optional)
  if (props.showOwner) {
    fields.splice(2, 0, {
      key: 'owner',
      label: 'Project owner',
      sortable: true,
      tdClass: 'align-middle',
    });
  }
  return fields;
});

function handleProjectRowClick(
  item: ProjectTypeExtended,
  index?: number,
  evt?: MouseEvent
) {
  openRouterLink(
    { name: 'ProjectDetail', params: { id: item.id } },
    router,
    evt
  );
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BAlert), {
      modelValue: noProjects.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((noProjects).value = $event)),
      variant: "secondary"
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode("No projects found.", -1)
      ]))]),
      _: 1
    }, 8, ["modelValue"]),
    (props.projects.length > 0)
      ? (_openBlock(), _createBlock(_unref(BCard), {
          key: 0,
          class: "mb-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BTable), {
              items: props.projects,
              busy: props.loading,
              fields: projectTableFields.value,
              small: "",
              responsive: "",
              hover: "",
              striped: "",
              class: "browser-table",
              onRowClicked: handleProjectRowClick
            }, {
              "cell(name)": _withCtx((data) => [
                _createElementVNode("strong", null, _toDisplayString(data.value), 1)
              ]),
              "cell(actions)": _withCtx((data) => [
                _createVNode(_unref(BButtonGroup), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BButton), {
                      size: "sm",
                      variant: "outline-secondary",
                      onClick: [
                        ($event: any) => (handleProjectRowClick(data.item, data.item.id, $event)),
                        _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "eye" })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["items", "busy", "fields"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})